// getConfigDetails.js
import { getPartnerDetails } from '../utils/helper'

const configDetails = Object.freeze({
  ENV: process.env.REACT_APP_ENV,

  // Local URLs
  customerLocalUrl: process.env.REACT_APP_CUSTOMER_LOCAL_URL,
  adminLocalUrl: process.env.REACT_APP_ADMIN_LOCAL_URL,

  // Base URLs
  baseURL: process.env.REACT_APP_API_BASE_URL,
  adminUrl: process.env.REACT_APP_ADMIN_URL,
  checkInUrl: process.env.REACT_APP_CHECKIN_URL,
  transientURL: process.env.REACT_APP_TRANSIENT_URL,
  portalURL: process.env.REACT_APP_PORTAL_URL,
  customerPortalURL: process.env.REACT_APP_CUSTOMER_PORTAL_URL,

  //rev admin
  revadminUrl: process.env.REACT_APP_API_BASE_URL || null,
  revcheckInUrl: process.env.REACT_APP_REV_CHECKIN_URL || null,
  revtransientURL: process.env.REACT_APP_REV_TRANSIENT_URL || null,
  revportalURL: process.env.REACT_APP_REV_CUSTOMERPORTAL_URL || null,
  revcustomerPortalURL: process.env.REACT_APP_REV_CUSTOMERPORTAL_URL || null,

  // Runtime (dynamic)
  get FACILITY_ID() {
    const source = process.env.REACT_APP_FACILITY_SOURCE

    if (source === 'runtime') {
      return getPartnerDetails()?.facilities?.[0]?.id ?? null
    }

    if (source === 'static') {
      const id = process.env.REACT_APP_FACILITY_ID ?? null
      return id ? Number(id) : null
    }

    return null
  },

  get PARTNER_ID() {
    return getPartnerDetails()?.clients?.partner_id ?? null
  },

  get CLIENT_ID() {
    return getPartnerDetails()?.clients?.id ?? null
  },

  get CLIENT_SECRET() {
    return getPartnerDetails()?.clients?.secret ?? ''
  },

  // Payment scripts
  googlePayScript: process.env.REACT_APP_GOOGLE_PAY_SCRIPT,
  payButtonScript: process.env.REACT_APP_PAY_BUTTON_SCRIPT,
  applePayScript: process.env.REACT_APP_APPLE_PAY_SCRIPT,

  applePayDTScript: process.env.REACT_APP_APPLE_PAY_DT_SCRIPT,
  payButtonDTScript: process.env.REACT_APP_PAY_BUTTON_DT_SCRIPT,
  applePayHLScript: process.env.REACT_APP_APPLE_PAY_HL_SCRIPT,

  googlePayDTScript: null,
  googlePayHLScript: null,
  payButtonHLScript: null,

  // iframeUrl: Datacap / Heartland card field scripts (key as the customer portals, else this portal's older keys)
  DCIframe: process.env.REACT_APP_DC_IFRAME_URL || process.env.REACT_APP_GATEWAY_DC_IFRAME || null,
  HLIframe: process.env.REACT_APP_HL_IFRAME_URL || process.env.REACT_APP_GATEWAY_HL_IFRAME || null,

  // Stripe 3DS / SCA popup: 'true' only once the backend has STRIPE_ENABLE_3DS_CONFIRMATION=true
  stripe3dsEnabled: process.env.REACT_APP_STRIPE_3DS_ENABLED === 'true',
  // Stripe test-mode "stripe" badge: hidden only when 'true', shown when missing / 'false'
  stripeHideTestBadge: process.env.REACT_APP_STRIPE_HIDE_TEST_BADGE === 'true',
  chiperKey: process.env.REACT_APP_CHIPER_KEY,

  // Google reCAPTCHA v3 (public site key only)
  recaptchaSiteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
})

// Payment components call getConfigDetails() as a function
export const getConfigDetails = () => configDetails

export default configDetails
